var exports = {
  "kL": "x2b2fbebb--bba696--container",
  "DD": "x2b2fbebb--bba696--title",
  "h_": "x2b2fbebb--bba696--description",
};

module.exports = exports;
